import { LangProps, TPAComponentProps } from '../../types';
import { ErrorMessageWrapperProps } from '../internal/ErrorMessageWrapper';

export enum RatingsSize {
  Small = 'small',
  Large = 'large',
}

export enum RatingsMode {
  Input = 'input',
  Display = 'display',
}

export enum RatingsLayout {
  Aside = 'aside',
  Bottom = 'bottom',
}

export enum RatingsLabelPlacement {
  Top = 'top',
  Aside = 'aside',
}

export interface RatingsProps extends TPAComponentProps, LangProps {
  value: number;
  labelPlacement?: RatingsLabelPlacement;
  label?: string;
  mode: RatingsMode;
  onSelect?(value: number): void;
  inputOptions?: string[];
  disabled?: boolean;
  error?: boolean;
  /**
   * The error message to display. This prop is relevant only for input mode.
   */
  errorMessage?: string;
  /** Appearance of error message. TextOnly | BackgroundAndBorder */
  errorAppearance?: ErrorMessageWrapperProps['errorAppearance'];
  size?: RatingsSize;
  layout?: RatingsLayout;
  ratingDisplay?: string;
  countDisplay?: string;
  'data-hook'?: string;
  name?: string;
  /* The aria-label that would be added for the stars. In case that you are passing `inputOptions` this would be the default aria-label values otherwise it would be the star indexes. */
  starsAriaLabels?: string[];
}

export interface RatingsDefaultProps {
  value: number;
  labelPlacement: RatingsLabelPlacement;
  disabled: boolean;
  error: boolean;
  mode: RatingsMode;
  size: RatingsSize;
  layout: RatingsLayout;
  inputOptions: string[];
  starsAriaLabels: string[];
}

export interface RatingsState {
  currentHovered: number;
}

export enum RatingsDataHooks {
  RatingContainer = 'rating-container',
  IconWrapper = 'icon-wrapper',
  InputOption = 'input-option',
  InputOptionCurrent = 'current-input-option',
  RatingInfo = 'rating-info',
  RatingLabel = 'rating-label',
}

export enum RatingsDataKeys {
  Error = 'data-error',
  Disabled = 'data-disabled',
  Size = 'data-size',
  Hovered = 'data-hovered',
}
